export class CAnswerStatus {
    fCode: number;
    fAcceptionNumber: string;
    fFirstName: string;
    fLastName: string;
    fAnswerStatus: number;
    fAnswerStatusDescription: string;
    fDebtPrice: number;

    constructor() {
        this.fCode = 0;
        this.fAcceptionNumber = "";
        this.fFirstName = "";
        this.fLastName = "";
        this.fAnswerStatus = 0;
        this.fAnswerStatusDescription = "";
        this.fDebtPrice = 0;
    }
}